import { media } from '../../../../helpers/breakpoints';

import styled from 'styled-components';

const Container = styled.div`
  border-radius: ${({ theme }) => theme.borderRadius.default};
  background-color: ${({ theme }) => theme.colors.WHITE};
  margin: ${({ theme }) => `${theme.spacing.S12} auto`};
  padding: ${({ theme }) => theme.spacing.M16};

  ${media.medium} {
    margin: ${({ theme }) => `${theme.spacing.M24} auto`};
    padding: ${({ theme }) => theme.spacing.M24};
  }

  ${media.large} {
    width: 468px;
  }
`;

export { Container };
